var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"+type-body-one +text-crop-none +font-circular-bold"},[_vm._v("\n  "+_vm._s(_vm.rate)+"% "+_vm._s(_vm.oaDataType)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }